import { useQuery } from '@tanstack/react-query'

import { supabase } from '@/lib/supabase/cliente'
import { mensajeDeError } from '@/lib/supabase/errores'
import type { RecorridoOrden } from '@/lib/supabase/tipos-bd'

/**
 * El archivo de servicios.
 *
 * Lo que ya terminó el recorrido, con las horas que pasó en cada fase. El
 * desglose no se guarda: sale de la bitácora, así que un servicio cerrado hace
 * un año se puede abrir hoy y sigue contando lo mismo.
 */
export function useServiciosFinalizados(termino: string) {
  const buscado = termino.trim()

  const consulta = useQuery({
    queryKey: ['servicios-finalizados', buscado],
    staleTime: 5 * 60 * 1000,
    queryFn: async (): Promise<RecorridoOrden[]> => {
      let peticion = supabase
        .from('vista_recorrido_orden')
        .select('*')
        .eq('terminado', true)
        .order('finalizado_en', { ascending: false })

      if (buscado.length >= 2) {
        // Por cliente, por número de orden o por el de la orden de trabajo:
        // es como se busca un acta cuando el cliente llama a pedirla.
        const patron = `%${buscado}%`
        peticion = peticion.or(
          [
            `cliente_nombre.ilike.${patron}`,
            `numero.ilike.${patron}`,
            `orden_trabajo_numero.ilike.${patron}`,
          ].join(','),
        )
      }

      const { data, error } = await peticion

      if (error) throw new Error(mensajeDeError(error))

      return (data ?? []) as unknown as RecorridoOrden[]
    },
  })

  return {
    servicios: consulta.data ?? [],
    cargando: consulta.isLoading,
    error: consulta.error?.message ?? null,
  }
}
